module.exports = __webpack_public_path__ + "img/dso_op.709b546d.png";